<template>
  <section>
    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'"
        @row-click="rowClick">
        <el-table-column
          width="69px"
          align="center">
          <template  #default="{ row }">
            <div class="flex-column  flex-align-center">
              <span
                v-if="row.merchant_platform"
                class="table-icon__img mg-b-8">
                <img :src="getOptionName('serverTypeIcon',row.merchant_platform)" >
              </span>
              <p class="icon icon-text">
                <font-awesome-icon
                  icon="dollar-sign" />
              </p>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="85px"
          label="Created">
          <template #default="{ row }">
            <div class="flex-algin time-text">
              <span>{{ row.quote_dt.split(" ")[0] }}</span><br>
              <span> {{ row.quote_dt.split(" ")[1] }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="80">
          <template #default="{ row }">
            <div class="flex-algin">
              <span>
                <p class="table-type">
                  <span>Renew</span>
                </p>
                <div
                  class="flex table-icon"
                  :class="{'ju_center': row.company_id == 0}">
                  <div v-if="row.company_id">
                    <span
                      v-tooltip="row.company_language"
                      class="icon icon-content">
                      <img
                        :src="getOptionData('companySmallIcon', row.company_id).logo? getOptionData('companySmallIcon', row.company_id).logo: row.company_logo">
                    </span>
                  </div>
                  <div>
                    <span
                      v-tooltip="row.class_language"
                      class="icon icon-content"
                    >
                      <font-awesome-icon
                        v-if="row.class_id"
                        :icon="getOptionName('iconOptions', row.class_id)" />
                    </span>
                  </div>
                </div>
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Plan Name">
          <template #default="{ row }">
            <div
              class="flex-algin"
              @click="rowClick(row)" >
              <router-link
                class="showLick"
                :to="rowClickFn(row)">
                <span class="span-label">{{ row.insurer }} {{ row.class_id>50?row.product_type:row.plan}}</span>
              </router-link>
              <p
                v-if="row.quotation_number"
                class="phone-text">
                {{row.quotation_number}}
              </p>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="105px"
          label="Price">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="first-text summary">{{ row.price }} </p>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="105px"
          label="Account">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="span-name">{{ row.contact_nm }}</span>
              <span>
                <template v-if="row.identity == 2">
                  {{ row.contact_nm }}
                </template>
                <span class="phone-text"> {{ row.phone_no }}</span>
              </span>
              <p v-if="[0,1].includes(row.pcy_agreement_1)">
                <span class="flex flex-align-center">
                  <font-awesome-icon
                    icon="square-check"
                    class="mg-r-3 fs-12"
                    :class="{'pending_verify-color':row.pcy_agreement_1==0,'verified-color':row.pcy_agreement_1==1} "></font-awesome-icon>
                  <span
                    class="fs-12"
                    :class="{
                      'pending_verify-color': row.pcy_agreement_1 ==0,
                      'verified-color': row.pcy_agreement_1 == 1,
                    }">{{getOptionName('user_agreement_option',row.pcy_agreement_1) }}</span>
                </span>
              </p>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="89px"
          :show-overflow-tooltip="true"
          label="Referrer"
          prop="referrer_nm">
        </el-table-column>

        <el-table-column
          width="95"
          label="Period">
          <template #default="{ row }">
            <div class="flex-algin period-text">
              <span>{{ row.policy_period.split(" - ")[0] }}&nbsp;-</span><br>
              <span> {{ row.policy_period.split(" - ")[1] }}</span>
            </div>
          </template>

        </el-table-column>

        <el-table-column
          width="155px"
          label="Status">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="status-height">
                <span
                  class="span-status"
                  :class="{
                    'yellow-dark': [4, 7].includes(row.stts),
                    'blue': [1, 5].includes(row.stts),
                    'green': [10].includes(row.stts),
                    'red': [6].includes(row.stts),
                    'purple': [3].includes(row.stts)
                  }">
                  {{ row.stts_language }}
                </span>
              </p>
              <p
                v-for="(v,i) in row.tag_language"
                :key="i"
                class="status-height">
                <span
                  class="span-options"
                  :class="{
                    'red': [1].includes(v.id),
                    'gray': [2].includes(v.id)
                  }">{{v.name}}</span>
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <v-pagination
        :total="pageConfig.total"
        :current="pageConfig.currentPage"
        @currentChange="currentChange" />
    </div>
  </section>
</template>

<script>
import {getOrderList} from '@/api/order'
import MixinOptions from '@/mixins/options'
import {downloadFile} from '@/utils/download'
export default {
  name: 'RenewList',
  mixins: [MixinOptions],
  props:{
    filterData:{
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      tableData: [],
      pageConfig: {
        currentPage: 1,
        total: 10
      },
    }
  },
  watch:{
    filterData:{
      immediate:true,
      handler(val){
        this.currentChange(1)
      }
    }
  },
  mounted(){
    // this.network().getRenewalList()
  },
  methods: {
    rowClick(row){
      const { id, product_id,pcy_id,sme_versions } = row
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id: row.id,
          product_id: row.product_id,
          sme_versions
        }
      })
    },

    rowClickFn(row){
      const { id, product_id,pcy_id,sme_versions } = row
      return({
        path: '/records/quote/detail',
        query: {
          order_id: row.id,
          product_id: row.product_id,
          sme_versions
        }
      })
    },

    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getRenewalList()
    },

    network(){
      return {
        getRenewalList: async (otherParams) => {
          let {date=[],effective_date=[]} = this.filterData||{}
          let params = {
            page: this.pageConfig.currentPage,
            // start_dt: this.filterData.start_dt,
            // end_dt: this.filterData.end_dt,
            // company_id: this.filterData.company_id? [this.filterData.company_id] : null,
            // class_id: this.filterData.class_id,
            // search: this.filterData.search,
            // referrer_code: this.filterData.referrer_code,
            // merchant_platform:this.filterData.merchant_platform,
            // pcy_agreement_1:this.filterData.pcy_agreement_1,
            ...this.filterData,
            ...otherParams,
            quote_dt_start: this.filterData.start_dt,
            company_id: this.filterData.company_id? [this.filterData.company_id] : null,
            quote_dt_end: this.filterData.end_dt,
            cmnt_dt: effective_date[0],
            expry_dt: effective_date[1],
          }
          delete params.effective_date
          if(otherParams && otherParams.is_export == 1){
            const res = await getOrderList(params,{
              responseType: 'blob',
              timeout: 120000
            })
            downloadFile(res)
          }else{
            const {data} = await getOrderList(params)
            this.pageConfig.currentPage = data.current_page
            this.pageConfig.total = data.total
            this.tableData = data.data
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.page-container {
  position: relative;
  color: #303133;
  .table-type{
    margin-bottom: 6px;
    white-space: nowrap;
    span{
      font-weight: 600;
      font-size: 12px;
      border: 1px solid #6A737D;
      box-sizing: border-box;
      border-radius: 100px;
      padding: 0px 8px;
    }
  }
  .flex-algin {
    &.time-text{
      font-size: 12px;
    }
    .icon-text{
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      letter-spacing: -0.15px;
      color: #24292E;
      margin-left: 15px;
    }
    .phone-text{
      font-size: 12px;
      color: #6A737D;
      .weight-text{
        font-weight: 600;
      }
    }
    &.period-text{
      span{
        font-size: 12px;
      }
    }
    p, span {
      min-height: 20px;
    }
    .first-text{
      color: #24292E;
      font-size: 14px;
    }
    .summary{
      font-size: 12px;
      word-break: break-word;
    }
    .status-height{
      height: 23px;
    }
    .showLick{
      text-decoration: none;
    }
  }
  .table-icon{
    &.margin-top-flex{
      margin-top: 5px;
    }
    .icon{
      margin-right: 10px;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #e1e4e8;
    }
    .backgroud-width{
      background: #fff!important;
      border: 1px solid #e1e4e8;
    }
  }
  .ju_center{
    justify-content: center;
  }
  .span-name {
    display: block;
    color: #24292E;
    height: auto!important;
    font-size: 14px;
    word-break: break-word;
  }
  .span-label {
    display: block;
    color: #24292E;
    font-weight: 600;
    word-break: break-word;
    font-size: 14px;
    text-decoration: none;
    &:hover{
      color:  #0366D6;
    }
  }
  .span-status, .span-options {
    display: inline-block;
    padding: 0px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    max-width: 140px;
    word-break:keep-all;
    white-space:nowrap;
    height: 18px;
    min-height: 18px !important;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
  }
  .span-status{
    &.green {
      background: #28a745;
      color: white;
    }
    &.orange {
      background: #E36209;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.purple {
      background: #6F42C1;
    }
    &.blue {
      background: #0366D6;
    }
    &.red {
      background: #d73a49;
    }
    &.min-green {
      background: #dcffe4;
      color: #28a745;
    }
  }
  .span-options{
    border: 1px solid;
    &.gray {
      border-color: #586069;
      color: #586069;
    }
    &.green {
      border-color: #22863A;
      color: #22863A;
    }
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
    &.gold {
      border-color: #735C0F;
      color: #735C0F;
    }
    &.blue {
      border-color: #0366D6;
      color: #0366D6;
    }
    &.orange {
      border-color: #C24E00;
      color: #C24E00;
    }
    &.black {
      border-color: #24292E;
      color: #24292E;
    }
  }
  .icon-color{
    &.gray {
      color: #586069;
    }
    &.green {
      color: #22863A;
    }
    &.red {
      color: #D73A49;
    }
  }
}
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      //display: flex;
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
      //height: 40px;
     .cell{
       //min-height: 40px;
       line-height: 23px;
       position: relative;
       height: inherit;
       //margin-left: 10px;
       //margin-right: 10px;
       padding: 0;
       //padding: 5px 10px;
       //position: absolute;
       //top: 10px;
     }
    }
  }
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;

  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    /* Text/text-gray-dark */
    padding: 10px 0!important;
    color: #24292E!important;
    .cell{
      padding-left: 0;
    }
  }
  .button-border{
    display: inline-block;
    padding: 0px 10px;
    height: auto;
    //line-height: 30px;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #E1E4E8;
    color: #24292E;
    background: white;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;

  }
}
.verified-color{
  color: #22863a;
}
.pending_verify-color{
  color: #dbab09;
}
</style>
